export default {
    meta: {
        title: '已收集个人信息'
    }
};
